<form [formGroup]="statusInformation">
  <div class="row">
    <div class="form-group col-md-3 col-sm-12">
      <label for="statusId">{{words[language][ 'status' ] }}</label>
      <select formControlName="statusId" id="statusId"
        class="form-control form-control-sm text-dark">
        @for (status of inventoryStatuses; track status) {
          <option [value]="status.id">
          {{status.name}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-3 col-sm-12">
      <label for="startDate">Start Date</label>
      <input class="form-control form-control-sm text-dark" type="date" id="startDate"
        formControlName="startDate" autocomplete="off">
      </div>
      <div class="form-group col-md-3 col-sm-12">
        <label for="endDate">End Date</label>
        <input class="form-control form-control-sm text-dark" type="date" id="endDate"
          formControlName="endDate" autocomplete="off">
        </div>
        <div class="col-sm-3 d-flex align-items-center justify-content-center">
          <button type="button" class="btn btn-sm btn-outline-dark" id="save-btn" (click)="saveStatus()" [disabled]="statusInformation.invalid">Save</button>
          <button type="button" class="btn btn-sm btn-outline-dark ml-1" (click)="resetStatusInformationForm()">Cancel</button>
        </div>
      </div>
    </form>
    <div class="tableFixHead">
      <table class="table table-hover table-striped">
        <thead>
          <tr>
            <th>Status</th>
            <th>Days Ago</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (statusHistory of statusHistoryList; track statusHistory; let i = $index) {
            <tr>
              <td>{{statusHistory.inventoryStatus.name}}</td>
              <td>{{calculateDaysDiff(statusHistory.startDate,statusHistory.endDate)}}</td>
              <td>{{statusHistory.startDate | date:'shortDate'}}</td>
              <td>{{statusHistory.endDate | date:'shortDate'}}</td>
              <td>
                <button type="button" class="btn btn-sm btn-outline-dark"
                (click)="selectStatus(statusHistory)">Edit</button>
                @if (statusHistoryList.length !== 1) {
                  <div class="btn-group dropleft">
                    <button type="button" class="btn btn-sm btn-outline-danger ml-1" title="Delete" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >Delete</button>
                    <div class="dropdown-menu text-center p-2">
                      <span class="uil-trash-alt text-danger h1"></span>
                      <p class="text-dark">Are you sure you want to delete this status from the inventory history?</p>
                      <div class="d-flex mt-1">
                        <button class="btn btn-danger btn-sm ml-2" (click)="deleteStatus(statusHistory.id)">{{words[language][ 'yes' ]}}</button>
                        <button class="btn btn-secondary btn-sm ml-2">No</button>
                      </div>
                    </div>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
